import { useMutation } from '@tanstack/react-query';
import { getCurrentSimuladao } from '../queries/simuladao';

function useGetCurrentSimuladao() {
  const { data, isError, error, isSuccess, isPending, mutate } = useMutation({
    mutationKey: ['get-current-simuladao'],
    mutationFn: () => getCurrentSimuladao(),
    retry: false,
  });

  return {
    data,
    isError,
    isLoading: isPending,
    error,
    isSuccess,
    mutate,
  };
}

export { useGetCurrentSimuladao };
